import { Component, OnInit } from '@angular/core';

import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';

import moment from 'moment';

@Component({
  selector: 'app-app-connectivity',
  templateUrl: './app-connectivity.component.html',
  styleUrl: './app-connectivity.component.scss'
})
export class AppConnectivityComponent implements OnInit {

  workers: any;

  /** True when at least one row includes `connectivity.motion_heartbeat`. */
  showMotionColumn = false;

  monitor = '';
  group = '';

  filter:any = {
    search: '',
    monitors: [],
    groups: [],
  }

  monitors:any = [];
  groups:any = [];

  u = Utils;

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getWorkers();

  }

  getWorkers(){
    console.log(this.filter);

    let filter = { ...this.filter };

    filter.monitors = filter.monitors.join(",");
    filter.groups = filter.groups.join(",");

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }

    this.okService.loading = true;
    this.okService.get('reports/workerconnectivity', filter)
    .subscribe(
      (data) => {
      console.log(data.body);
      this.workers = data.body;
      this.refreshMotionColumnFlag();
      this.groups = this.okService.groups;
      this.monitors = this.okService.monitors;
        this.okService.loading = false;
      },
      (error) => {
        console.error('Error fetching worker connectivity data:', error);
        this.okService.loading = false;
      }
    );
  }

  updateFilter(){
    this.getWorkers();
  }

  clearFilter(){
    this.filter = {
      search: '',
      monitors: [],
      groups: [],
    };
    this.getWorkers();
  }

  export(){
    const fields: any = { ...this.filter, export: true };
    fields.monitors = Array.isArray(fields.monitors) ? fields.monitors.join(",") : "";
    fields.groups = Array.isArray(fields.groups) ? fields.groups.join(",") : "";
    fields.search = fields.search ? fields.search : "";

    this.okService.download("reports/workerconnectivity",fields);

  }

  private refreshMotionColumnFlag(): void {
    const list = this.workers;
    // this.showMotionColumn =
    //   Array.isArray(list) &&
    //   list.some((w: any) => this.motionHeartbeatVisible(w?.connectivity?.motion_heartbeat));
  }

  motionHeartbeatVisible(motionHeartbeat: { time?: string | null } | null | undefined): boolean {
    if (!motionHeartbeat) {
      return false;
    }
    return String(motionHeartbeat.time ?? '').trim() !== '';
  }

  motionHeartbeatLabel(motionHeartbeat: { activity?: string | null } | null | undefined): string {
    if (!motionHeartbeat) {
      return 'Motion';
    }
    const activity = motionHeartbeat.activity;
    if (activity == null || String(activity).trim() === '') {
      return 'Motion';
    }
    const normalized = String(activity).trim().toLowerCase();
    if (normalized === 'unknown') {
      return 'Motion';
    }
    return String(activity).trim();
  }

  motionHeartbeatBadgeColor(minutesSince: number | null | undefined): string {
    const mins = minutesSince == null || Number.isNaN(Number(minutesSince)) ? 999 : Number(minutesSince);
    if (mins < 20) {
      return 'success';
    }
    if (mins < 45) {
      return 'warning';
    }
    return 'danger';
  }

}

